import WMPConsent from "./WMPConsent";

export default WMPConsent;
